// Generated by scripts/generate-env.mjs from process.env and .env.local. Do not commit.
export const process = {
  env: {
    SITE_URL: "",
    SITE_URL_DEV: "",
    SITE_URL_PROD: "",
    CART_WORKER_URL: "",
    CART_WORKER_URL_DEV: "",
    CART_WORKER_URL_PROD: "",
    CONTENTFUL_SPACE_ID: "seijmf0nkcxs",
    CONTENTFUL_ENVIRONMENT: "development",
    CONTENTFUL_ENVIRONMENT_PROD: "master",
    CONTENTFUL_DELIVERY_TOKEN: "u4JTEVgAi-KbxnJZIaT_576R06oiMsU__zEttDPAO-0",
    CONTENTFUL_DELIVERY_TOKEN_PROD: "u4JTEVgAi-KbxnJZIaT_576R06oiMsU__zEttDPAO-0",
    CONTENTFUL_PREVIEW_TOKEN: "Gnv319GsIxptoPF3-b1OkbupRs9dvQd2kTfaDOVDldo",
  },
};
